import { render, staticRenderFns } from "./CreateSerialNumber.vue?vue&type=template&id=7f4f0c4c&scoped=true&"
import script from "./CreateSerialNumber.vue?vue&type=script&lang=ts&"
export * from "./CreateSerialNumber.vue?vue&type=script&lang=ts&"
import style0 from "./CreateSerialNumber.vue?vue&type=style&index=0&id=7f4f0c4c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f4f0c4c",
  null
  
)

export default component.exports